import React, { Component } from "react";
import PropTypes from "prop-types";
import { grey } from "material-ui/colors/index";
import { Typography } from "material-ui";
import { CloudQueue } from "material-ui-icons";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({
    empty: {
        textAlign: "center"
    },
    emptyOutline: {
        height: 200,
        width: 200,
        fill: grey[500]
    }
});

class EmptyState extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        message: PropTypes.string.isRequired
    };

    render() {
        let { classes, message } = this.props;
        return (
            <div className={classes.empty}>
                <CloudQueue className={classes.emptyOutline} />
                <Typography type="body1">
                    {message}
                </Typography>
            </div>
        );
    }
}

export default withStylesAndTranslation(EmptyState, styleSheet);



// WEBPACK FOOTER //
// ./src/components/EmptyState.jsx